export default __webpack_public_path__ + "static/media/pencil.bc17a020.svg";